export enum AboutPagesEnum {
  AboutTheProject = 1,
};